// extracted by mini-css-extract-plugin
export default {"footer_container":"styles_footer_container__AeSup","text":"styles_text__w90mx"};